const initMegaMenu = () => {
    const megaMenuItems = document.querySelectorAll('.mega-menu--item');

    megaMenuItems.forEach(ele => {
        console.log('Mega menu item:', ele);

        const linkTitles = ele.querySelectorAll('.mega-menu__link--title');
        const linkListItems = ele.querySelectorAll('.mega-menu__link--list__item');
        const linksContent = ele.querySelector('.mega-menu__list--content');
        const itemBannersContainer = ele.querySelector('.mega-menu__item-banners');

        linkTitles.forEach(title => {
            title.addEventListener('mouseenter', () => {

                linkTitles.forEach(title => title.classList.remove('active'));
                title.classList.add('active');

                const targetSubmenuId = title.dataset.targetSubmenuId;
                
                // Get the ID of the hovered title
                const titleId = title.id;
                if (titleId) {
                    // Find the corresponding content item with the same ID
                    const correspondingItem = linksContent.querySelector(`#${titleId}`);
                    if (correspondingItem) {
                        linkListItems.forEach(item => item.classList.remove('active'));
                        correspondingItem.classList.add('active');
                    }
                    
                    if (correspondingBanner) {
                        const correspondingBanner = itemBannersContainer.querySelector(`#${targetSubmenuId}`);
                        const itemBanners = itemBannersContainer.querySelectorAll('.mega-menu__submenu--item');
                        itemBanners.forEach(banner => {
                            if(banner.classList.contains('active')) {
                                banner.classList.remove('active');
                                banner.classList.add('hide')
                            }
                        });

                        correspondingBanner.classList.remove('hide');
                        correspondingBanner.classList.add('active');
                    }
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', initMegaMenu);